import { companyStats } from "@/mocks/company";

export default function BrandIntro() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="container-site grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div className="order-2 lg:order-1">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-700">
            About Mango Media
          </span>
          <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-3 leading-tight">
            十八年专注，<br className="hidden md:block" />
            只为一件事：做好内容
          </h2>
          <p className="text-foreground-700 mt-5 leading-relaxed text-sm md:text-base">
            芒果传媒是一家集影视制作、节目策划与内容发行于一体的综合型内容机构。从电影、剧集到综艺、纪录片，我们用专业与热忱，把每一个故事讲给更多人听。
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mt-8">
            {companyStats.map((s) => (
              <div key={s.label} className="flex flex-col">
                <span className="font-heading font-extrabold text-2xl md:text-3xl text-primary-700">
                  {s.value}
                </span>
                <span className="text-xs md:text-sm text-foreground-600 mt-1">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="order-1 lg:order-2 relative">
          <div className="w-full aspect-[4/3] rounded-lg overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20film%20production%20team%20working%20behind%20the%20scenes%20with%20cameras%20and%20warm%20lights%2C%20collaborative%20atmosphere%2C%20cinematic%20tones%2C%20no%20text&width=1200&height=900&seq=mango-brand-intro&orientation=landscape"
              alt="芒果传媒制作团队"
              title="芒果传媒制作团队"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-5 -left-4 md:-left-6 bg-accent-500 rounded-lg px-5 py-4 hidden sm:block">
            <span className="font-heading font-extrabold text-2xl text-background-50 block">300+</span>
            <span className="text-xs text-background-100">部作品陪伴观众成长</span>
          </div>
        </div>
      </div>
    </section>
  );
}